import FilterForm from 'components/forms/FilterForm';
import {
  Empty,
  Form,
  FormProps,
  Input,
  Radio,
  RadioChangeEvent,
  Select
} from 'antd';
import { ICourse } from 'interfaces/courses';
import { IGraduateDiscipline } from 'interfaces/graduate_disciplines';
import { useCallback, useMemo, useState } from 'react';
import { useSelect } from '@refinedev/antd';

export interface IDiscussionThreadsFilter {
  by_grandparent_type: 'Course' | 'Graduate::Discipline';
  by_grandparent_id: string;
  by_status: string;
  by_user_name: string;
  by_user_email: string;
}

interface FilterFormProps {
  searchFormProps: FormProps<IDiscussionThreadsFilter>;
}

export const DiscussionThreadsFilter = ({
  searchFormProps
}: FilterFormProps) => {
  const [selectedType, setSelectedType] = useState('Course');

  const { selectProps: disciplineSelectProps } = useSelect<IGraduateDiscipline>(
    {
      resource: 'graduate_disciplines',
      optionLabel: 'name',
      optionValue: 'id',

      onSearch: value => [
        {
          field: 'filter[name]',
          operator: 'eq',
          value
        }
      ],

      pagination: {
        mode: 'server',
        pageSize: 100
      }
    }
  );

  const { selectProps: courseSelectProps } = useSelect<ICourse>({
    resource: 'courses',
    optionLabel: 'name',
    optionValue: 'id',

    onSearch: value => [
      {
        field: 'filter[name]',
        operator: 'eq',
        value
      }
    ],

    pagination: {
      mode: 'server',
      pageSize: 100
    }
  });

  const onChangeType = useCallback((e: RadioChangeEvent) => {
    const value = e.target.value;
    setSelectedType(value);
  }, []);

  const selectProps = useMemo(() => {
    return selectedType === 'Course'
      ? courseSelectProps
      : disciplineSelectProps;
  }, [courseSelectProps, disciplineSelectProps, selectedType]);

  return (
    <FilterForm searchFormProps={searchFormProps}>
      <Form.Item
        name="current"
        label="Tupo de curso"
        className="mb-0 "
        initialValue="Course"
      >
        <Radio.Group onChange={onChangeType}>
          <Radio.Button value="Course">Curso</Radio.Button>
          <Radio.Button value="Graduate::Discipline">Disciplina</Radio.Button>
        </Radio.Group>
      </Form.Item>

      <Form.Item name="by_grandparent_id" className="mb-0">
        <Select
          {...selectProps}
          placeholder="Nome do curso ou disciplina"
          allowClear
          notFoundContent={
            <Empty
              description={`${
                selectedType === 'Course'
                  ? 'Nenhum curso encontrado'
                  : 'Nenhuma disciplina encontrada'
              }. Tente refazer sua busca com outros termos`}
            />
          }
        />
      </Form.Item>

      <Form.Item name="by_user_name">
        <Input placeholder="Nome do aluno" />
      </Form.Item>

      <Form.Item name="by_user_email">
        <Input placeholder="E-mail do aluno" />
      </Form.Item>

      <Form.Item name="by_status">
        <Select placeholder="Selecione o status" defaultValue={null}>
          <Select.Option>Todos</Select.Option>
          <Select.Option key="pending">Não resolvida</Select.Option>
          <Select.Option key="answered">Respondida</Select.Option>
          <Select.Option key="closed">Encerrada</Select.Option>
        </Select>
      </Form.Item>
    </FilterForm>
  );
};
